// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__0KI+-","flash":"Loader_flash__ZoBmA"};